"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EspoolSubKetteType = void 0;
var EspoolSubKetteType;
(function (EspoolSubKetteType) {
    EspoolSubKetteType["linear"] = "linear";
    EspoolSubKetteType["twisterband"] = "twisterband";
})(EspoolSubKetteType = exports.EspoolSubKetteType || (exports.EspoolSubKetteType = {}));
//# sourceMappingURL=EspoolSubKetteType.js.map